<template>
	<div id="laboratories-request" class="bg-primary py-5 text-center text-white">
		<div class="container" :class="{'disabled': currentReqLab}">
				<div class="row">
					<div class="col-12">
						<h2 class="fs-2-3">I laboratori con il divulgatore per la tua scuola</h2>
						<p>
							Tra tutti i docenti che lo richiederanno, verranno selezionate alcune classi che potranno beneficiare di un <strong>vero laboratorio live</strong> (in presenza o online) <strong>con i divulgatori scientifici di Fondazione Umberto Veronesi</strong>.
							Spunta la casella sottostante se vuoi richiedere un laboratorio. Le classi selezionate verranno contattate ai recapiti forniti in fase di registrazione.
						</p>
					</div>
					<div class="col-12">
						<form id="laboratories-request-form" @submit.prevent="reqLab">
							<div class="row">
								<div class="col-12">
									<div class="row">
										<div class="col-12 form-group custom-form-check mt-2 mb-3">
											<input id="laboratories-req" class="checkbox-custom" name="laboratories-req" type="checkbox" required v-model="reqCheck">
											<label for="laboratories-req" class="checkbox-custom-label black">
												<span class="bold" style="vertical-align: inherit;">Mi piacerebbe che la mia classe fosse scelta per partecipare al laboratorio</span>
											</label>
										</div>
									</div>
									<div class="row">
										<div class="col-12 text-center">
											<button type="submit" class="btn btn-black rounded-pill" style="border: 4px solid #000000;" :disabled="currentReqLab"><span class="va-m">CONFERMA</span></button>
										</div>
									</div>
									<div class="row" v-if="msgForm">
										<div class="col-12 text-center mt-2">
											<p class="msg mb-0">{{msgForm}}</p>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	data() {
		return {
			ajaxObj: window.ajax_object,
			reqCheck: false,
			currentReqLab: false,
			msgForm: ''
		}
	},

	methods: {
		reqLabCurrentStatus() {
				let url = this.ajaxObj.ajax_url

				var data = new FormData();
				data.append('action', 'nl_get_lab_req_status')
				data.append('_nounce_value', this.ajaxObj._nounce_value)

				axios.post(url, data)
					.then((response) => {
						if(response.data.req_status == 1) {
							this.reqCheck = true
							this.currentReqLab = true
						}
						// console.log(response.data)
					}, (error) => {
						console.log(error);
					});
		},

		reqLab() {
			let url = this.ajaxObj.ajax_url

			var data = new FormData();
			data.append('action', 'nl_set_lab_req_status')
			data.append('_nounce_value', this.ajaxObj._nounce_value)

			axios.post(url, data)
				.then((response) => {
					if(response.data.req_status == 1) {
						this.reqCheck = true
						this.currentReqLab = true
					}
					// console.log(response.data)
				}, (error) => {
					console.log(error);
				});
		}
	},

	mounted() {
		this.reqLabCurrentStatus()
	}
}
</script>

<style scoped>
	.disabled {opacity: .6;}
</style>
